export function getCalendarDayPopupPlacement(dayIdx) {
  const col = dayIdx % 7;

  let horizontal;
  if (col <= 1) {
    horizontal = { className: "left-0", centered: false };
  } else if (col >= 5) {
    horizontal = { className: "right-0 left-auto", centered: false };
  } else if (col === 2) {
    horizontal = { className: "left-0", centered: false };
  } else if (col === 3) {
    horizontal = { className: "left-1/2", centered: true };
  } else {
    horizontal = { className: "right-0 left-auto", centered: false };
  }

  return {
    horizontal,
    vertical: "top-full pt-2",
    showAbove: false,
  };
}
